if (!customElements.get('videos-slider')) {
  customElements.define(
    'videos-slider',
    class VideosSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.swiperEl = this.querySelector('.mySwiper');
        this.swiper = this.querySelector('.mySwiper');
        this.allVideos = this.querySelectorAll('video');
        this.documentAllVideos = document.querySelectorAll('.vid-slid__video video');
        this.allItems = this.querySelectorAll('.vid-slid__item');
        this.isVideoIntersecting = false;
        this.muted = true;

        this.activeClass = 'vid-slid__item--active';

        const loadVideo = (video) => {
          const sources = video.querySelectorAll('source[data-src]');

          if (!sources.length) return;

          sources.forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });

          video.load();
        };

        const toggleVideoStatus = (video) => {
          const videoContainer = video.closest('.vid-slid__item');

          if (video.paused) {
            loadVideo(video);

            this.documentAllVideos.forEach((vid) => {
              vid.pause();
              vid.closest('.vid-slid__item').classList.remove(this.activeClass);
            });

            video.play();
            if (videoContainer) videoContainer.classList.add(this.activeClass);
          } else {
            video.pause();
            if (videoContainer) videoContainer.classList.remove(this.activeClass);
          }
        };

        this.allVideos.forEach((video) => {
          video.pause();
        });

        this.allItems.forEach((item, index) => {
          const videoContainer = item.querySelector('.vid-slid__video');
          const video = item.querySelector('video');
          const videoSoundButton = item.querySelector('.vid-slid__video-sound-button');
          const loader = item.querySelector('.video-loader');

          videoContainer.addEventListener('click', (e) => {
            toggleVideoStatus(video);
          });

          // Kiedy video jest gotowe do odtworzenia
          video.addEventListener('canplaythrough', () => {
            loader.classList.add('hidden');
          });

          videoSoundButton.addEventListener('click', (e) => {
            e.stopPropagation();
            if (this.muted) {
              this.allVideos.forEach((vid) => {
                vid.muted = false;
              });
              this.muted = false;
              this.swiperEl.classList.add('vid-slid__swiper--muted');
            } else {
              this.allVideos.forEach((vid) => {
                vid.muted = true;
              });
              this.muted = true;
              this.swiperEl.classList.remove('vid-slid__swiper--muted');
            }
          });

          // Gdy user kliknie play
          video.addEventListener('play', () => {
            loader.classList.add('hidden');
          });
          // Gdy user kliknie play
          video.addEventListener('pause', () => {
            loader.classList.add('hidden');
          });

          // Jeśli się buforuje
          video.addEventListener('waiting', () => {
            if (video.played) loader.classList.remove('hidden');
          });

          // Jeśli znów gra
          video.addEventListener('playing', () => {
            loader.classList.add('hidden');
          });

          video.addEventListener('ended', () => {
            if (index < this.allItems.length - 1 && !this.swiper.enabled) {
              const nextVideo = this.allVideos[index + 1];
              toggleVideoStatus(nextVideo);
            } else if (index === this.allItems.length - 1 && !this.swiper.enabled) {
              const nextVideo = this.allVideos[0];
              toggleVideoStatus(nextVideo);
            } else if (this.swiper.enabled) {
              this.swiper.slideNext();
            }
          });

          video.addEventListener('play', () => console.log('PLAYING', video));
          video.addEventListener('pause', () => console.log('PAUSED', video));
        });

        // document.addEventListener('DOMContentLoaded', () => {
        this.swiper = new Swiper(this.swiper, {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 0,
          loop: false,
          centeredSlides: false,
          slideToClickedSlide: true,
          snapToAlignment: 'start',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            1280: {
              enabled: false,
            },
          },
        });
        // });

        this.swiper.on('slideChange', (e) => {
          const videoSlide = e.slides[e.activeIndex];
          // this.allVideos.forEach((vid) => vid.pause());

          const video = videoSlide.querySelector('video');
          setTimeout(() => {
            toggleVideoStatus(video);
          }, 50);
        });

        // // Ustawienie obserwatora
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;

              if (entry.isIntersecting && !this.isVideoIntersecting) {
                toggleVideoStatus(video);
                this.isVideoIntersecting = true;
              } else {
                // video.pause();
              }
            });
          },
          {
            threshold: 0.5, // min. 50% elementu musi być widoczne
          }
        );

        // Podpięcie obserwatora do każdego video
        observer.observe(this.allVideos[0]);
        // this.allVideos.forEach((video) => observer.observe(video));
      }
    }
  );
}
